<template>
    <div>
        <DxDataGrid
            ref="gridRef"
            :data-source="gridData"
            key-exp="TableId"
            :selection="{ mode: 'multiple', showCheckBoxesMode: 'always' }"
            @toolbar-preparing="onGridToolbarPreparing"
            @row-inserted="gridRowCreated"
            @row-updated="gridRowUpdated"
            @row-removed="gridRowDeleted"
            @selection-changed="gridSelectionChanged"
        >
          <DxEditing
            :allow-updating="true"
            :allow-deleting="true"
            :allow-adding="true"
            mode="popup"
            :texts="{ confirmDeleteMessage: 'Are you sure you want to delete this table?' }"
            
          >
            <!-- This Popup does not support event binding, because it is within the grid -->
            <DxPopup
              :show-title="false"
              :width="500"
              :height="230"
              title="Table"
            >
              <DxPosition
                my="center"
                at="center"
                of="window"
              />
            </DxPopup>
                    
            <DxForm :col-count="1">
              <DxItem
                :col-count="1"
                :col-span="1"
                item-type="group"
              >
                <DxItem data-field="TableName"/>
                <DxItem data-field="TableDesc"/>
              </DxItem>
            </DxForm>

          </DxEditing>>
          <DxColumn
              data-field="TableId"
              caption="Table Id"
              data-type="text"
              :visible="false"
          />
          <DxColumn
              data-field="TableName"
              caption="Table Name"
              data-type="text"              
              sort-order="asc"
          />
          <DxColumn
              data-field="TableDesc"
              caption="Description"
              data-type="text"
          />
          <DxColumn
              data-field="TableURL"
              caption="Url"              
          />
          <DxColumn
              data-field="Url"
              caption=""              
              cell-template="qr-template"
          />

          <template #qr-template="{ data }">
            <div>
              <!-- data.value is the data-field -->
              <!--<div style="color:blue">{{ data.value }}</div>-->
              <!--<div style="color:blue">{{ data.value }}</div>-->
              <!--Nope--<div style="color:blue">{{ data.cell.text }} testing</div>-->
              <DxButton ref="QrCodeButtonRef" 
                :width="120"
                type="normal"
                text="QR Code"
                styling-mode="outlined"
                :visible="true"
                @click="onQrClick(data)"
                :element-attr="qrCodeButtonAttr"
              />
            </div>
          </template>

        </DxDataGrid>

        <!-- This DxPopup is created outside of the DxDataGrid.  
             If it was inside the grid, you would get one popup per record each time the QR Code button is clicked -->
        <DxPopupReg
          :visible.sync="qrCodeVisible"
          :drag-enabled="true"
          :close-on-outside-click="true"
          :show-title="true"
          :width="260"
          :height="340"
        >

          <!-- Display the Description of the table -->
          <div class = "dx-field center-text qr-url">
            {{qrBaseUrl}}<span class="code dinesafe-red">{{locationSixCharCode}}</span>
          </div>
          <div class = "dx-field center-text qr-tablename">
            {{qrTableName}}
          </div>

          <QrCode 
            class="qr-code-image"
            ref="QrCodeImageRef" 
            :value.sync="qrCodeValue"
          />
          <div class="popup-print-button">
            <DxButton ref="QrPrintButtonRef" 
              :width="120"
              type="normal"
              text="Print"
              styling-mode="outlined"
              :visible="true"
              @click="onQrPrintClick()"
            />
          </div>
        </DxPopupReg>

        <!--<DxPopupReg
          ref="printMultiplePopupRef"
          :visible.sync="qrCodeMultipleVisible"
          :drag-enabled="true"
          :close-on-outside-click="true"
          :show-title="true"
          :width="800"
          :height="800"
        >
          <QrCodeMultiple
            ref="printMultiplePopupRef"
            :popupVisible.sync="qrCodeMultipleVisible"
            :selectedQrCodes="selectedQrCodes"
          />
        </DxPopupReg>-->

        <QrCodeMultiple
          ref="QrCodeMultipleRef"
          :selectedQrCodes="selectedQrCodes"
        />

    </div>
</template>

<script>
    
import { DxDataGrid, DxColumn, DxEditing, DxPosition, DxForm, DxPopup} from 'devextreme-vue/data-grid';
//import adminData from '../../../src/data/admin-data.js';
import shared from '../../utils/contact-tracing-functions';
import DxButton from "devextreme-vue/button";
import DxPopupReg from 'devextreme-vue/popup';
import QrCode from 'vue-qrcode'
import { DxItem } from 'devextreme-vue/form';
import QrCodeMultiple from '../../components/qr-code-multiple.vue';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxButton,
    DxPopup,
    QrCode,
    DxEditing,
    DxPosition,
    DxForm,
    DxItem,
    DxPopupReg,
    QrCodeMultiple,
  },
  data() {
    return {
      //gridData: adminData.getAdminTablesTestData()[0].rows,
      //gridData: null, //this.$store.state.data.locationData,
      selectedQrCodes: null,      
      /*[ { "LocationId": "92638EDF-353B-4D22-9C89-7CA6B143DD9B", "TableName": "Farmhouse Table 10", "TableDesc": "Table 10", "TableURL": "https://csl.cslusdata.com/dinesafevt/#/5BB95B" },
                            { "LocationId": "AB0451FE-5F69-48D6-9843-84B302B4893C", "TableName": "Farmhouse Table 1", "TableDesc": "Table 1", "TableURL": "https://csl.cslusdata.com/dinesafevt/#/5BB951" } ,
                            { "LocationId": "BB0451FE-5F69-48D6-9843-84B302B4893C", "TableName": "Farmhouse Table 2", "TableDesc": "Table 2", "TableURL": "https://csl.cslusdata.com/dinesafevt/#/5BB952" } ,
                            { "LocationId": "CB0451FE-5F69-48D6-9843-84B302B4893C", "TableName": "Farmhouse Table 3", "TableDesc": "Table 3", "TableURL": "https://csl.cslusdata.com/dinesafevt/#/5BB953" } ,
                            { "LocationId": "DB0451FE-5F69-48D6-9843-84B302B4893C", "TableName": "Farmhouse Table 4", "TableDesc": "Table 4", "TableURL": "https://csl.cslusdata.com/dinesafevt/#/5BB954" } ,
                            { "LocationId": "EB0451FE-5F69-48D6-9843-84B302B4893C", "TableName": "Farmhouse Table 5", "TableDesc": "Table 5", "TableURL": "https://csl.cslusdata.com/dinesafevt/#/5BB955" } ,
                              { "LocationId": "FB0451FE-5F69-48D6-9843-84B302B4893C", "TableName": "Farmhouse Table 6", "TableDesc": "Table 6", "TableURL": "https://csl.cslusdata.com/dinesafevt/#/5BB956" } 
                            ],*/
      
      gridData: this.$store.state.data.locationData,
      qrCodeVisible: false,
      qrCodeMultipleVisible: false,
      qrLabel: '',
      qrTableName: '',
      qrCodeValue: '',
      qrBaseUrl: '',
      locationSixCharCode: '',
      qrCodeButtonAttr: {
          class: 'qr-code-button'
      }
    };
  },
  created(){
    //Load information to the DataGrid
    //this.getLocationData(this.$store.state.data.currentAccountId);

    //var accountId = this.$store.state.data.currentAccountId;
    var accountId = localStorage.dinesafeAccountId;

    this.$http.post(this.$store.state.appSettings.webServiceUrl + 'GetLocationData',
      {
        AccountId: accountId,
      }
      ).then(function(data){         
          var responseData = JSON.parse(data.body);        

          this.$store.commit("setLocationData", responseData["Locations"]);

          //this.gridData = this.$store.state.data.locationData;

          //If the dataset is empty, add a record to it to set the schema
          if(this.$store.state.data.locationData == null){
             this.$store.commit("setLocationData", 
                [
                  {
                      "LocationId": -1,
                      "TableDesc": '', 
                      "TableName": null,
                      "TableURL": null,
                    },
                ]            
            );
          }

          this.gridData = this.$store.state.data.locationData;
          
          //Hide the dummy record we just created in the grid
          this.$refs.gridRef.instance.filter([
            ["LocationId","<>", -1],
          ]);
      });
  },
  methods: {
    /*
      Show a popup with an image of the QR Code
    */
    onQrClick(data){
      //console.log("onQrClick");

      //Set the text in the popup
      this.qrLabel = data.data.TableURL;
      this.qrTableName = data.data.TableName;

      this.locationSixCharCode = this.qrLabel.substring(this.qrLabel.length, this.qrLabel.length-6);
      this.qrBaseUrl = this.qrLabel.substring(0, this.qrLabel.length-6);

      //console.log("data.data.Url: " + data.data.Url);
      this.qrCodeValue = data.data.TableURL;

      //Show the QR Code popup
      this.qrCodeVisible = true;
    },

    /*
      Open a Print dialog for printing the QR Code
    */
    onQrPrintClick(){
      //Get the QR Code image
      var source = this.$refs.QrCodeImageRef.$el.src;

      //var Pagelink = "about:blank";
      var pwa = window.open("");
      pwa.document.open();
      pwa.document.write(this.ImagetoPrint(source));
      
      pwa.document.write("<style>");
      pwa.document.write(".qr-code-image {   border-style:dashed;   border-width:1px;}");
      pwa.document.write("</style>");
      pwa.document.close();
    },
    /*
      Display the image correctly in the Print dialog window
    */
    ImagetoPrint(source)
    {
        return "<html><head><scri"+"pt>function step1(){\n" +
                "setTimeout('step2()', 10);}\n" +
                "function step2(){window.print();window.close()}\n" +
                "</scri" + "pt></head><body onload='step1()'>\n" +
                "<img class='qr-code-image' src='" + source + "' /></body></html>";
    },
    /*
      Open a Print dialog for printing the QR Code
    */
    //onQrPrintMultipleClick(){
    btnPrintMultipleClick(e){
      //Get the selected rows.  $data.selectedQrCodes is bound to a component that will render the selected QR Codes
      //this.$data.selectedQrCodes = this.$refs.gridRef.instance.getSelectedRowsData();

      //Get the html of the QR Code images and URLs
      var source = this.$refs.QrCodeMultipleRef.$el.innerHTML;

      //var Pagelink = "about:blank";
      var pwa = window.open("");
      pwa.document.open();
      pwa.document.write(this.ImagetoPrintMultiple(source));
      
      //Add the css styles
      pwa.document.write("<style>");
      //pwa.document.write(".qr-code-multiple {   border-style:dashed;   border-width:1px;}");
      pwa.document.write(".qr-code-multiple{   display:inline-table; border: 1px; border-style:dashed; padding-top: 30px; padding-bottom: 30px; width:300px; } " + 
        " .qr-tablename{ font-weight: bold; }" +
        " .center-text { display:block; text-align:center; margin:auto;}" + 
        " .code{ font-weight: bold; color: #A2293C; }");
        
      pwa.document.write(".qr-code-image{ margin:auto; display:block;}");
      pwa.document.write(".tableurl{padding:20px;}");
      pwa.document.write("</style>");
      pwa.document.close();      
    },

    /*
      Display the image correctly in the Print dialog window
    */
    ImagetoPrintMultiple(source)
    {
        return "<html><head><scri"+"pt>function step1(){\n" +
                "setTimeout('step2()', 10);}\n" +
                "function step2(){window.print();window.close()}\n" +
                "</scri" + "pt></head><body onload='step1()'>\n" +
                source + "</body></html>";
    },
    onGridToolbarPreparing(e){
      //e.toolbarOptions.items...

      //console.log("toolbarPreparing");

      let toolbarItems = e.toolbarOptions.items;

      //Customize the ADD button
      toolbarItems.forEach(function(item) {
      if (item.name === "addRowButton") {
          // Change the item options here
          item.options.stylingMode = 'outlined';
          item.options.text = 'Add';
        }
      });

      // Add a PRINT buttom
      toolbarItems.push({
          widget: 'dxButton',
          options: {
              icon: 'print',
              text: 'Print',
              stylingMode: 'outlined',
              onClick: this.btnPrintMultipleClick,
          },
          location: 'before'
      });
    },
    //Update an existing location record
    gridRowUpdated(e){
      // eslint-disable-next-line
      //console.log("gridRowUpdated");

      shared.updateLocationRecord(this, e.data);
    },
    /*
      Add a new Table (aka Location) for the Account
      Stored proc = pr_admin_AddNewLocation
    */      
    gridRowCreated(e){
      // eslint-disable-next-line
      //console.log("gridRowCreated");

      this.$http.post(this.$store.state.appSettings.webServiceUrl + 'CreateLocationRecord',
      {
        //AccountId: this.$store.state.data.currentAccountId,
        AccountId: localStorage.dinesafeAccountId,
        LocationName: e.data.TableName,
        LocationDesc: e.data.TableDesc,
      }
      ).then(function(data){         
         if(data.body != null && data.body != '')
         {
            var responseData = JSON.parse(data.body); 

            //Refresh the grid          
            this.$store.commit("setLocationData",  responseData.Locations);
            this.gridData = this.$store.state.data.locationData;
         }
      });
    },
    gridRowDeleted(e){
      // eslint-disable-next-line
      //console.log("gridRowDeleted");

      shared.deleteLocationRecord(this, e.data);
    },
    /*
      Grid row selection changed
      When a row is selected/deselected, build the html for the QR Codes.  
      This html is hidden on the page, but is used when the PRINT button is selected.
      The PRINT button gets the html of the generated QR Code images, and opens a new page that can be printed.
    */
    gridSelectionChanged(e){
      console.log("gridSelectionChanged");

      //Get the selected rows.  $data.selectedQrCodes is bound to a component that will render the selected QR Codes
      this.$data.selectedQrCodes = this.$refs.gridRef.instance.getSelectedRowsData();  
    },
  }
}

</script>

<style scoped>
  @import '../../themes/contact-tracing.css';

  /* Format the QR images as a grid/table */
  .qr-code-multiple{
   
    display:inline-table; /* inline-flex could also work */
    /*border: 1px;
    border-style:dashed;*/
    padding-top: 30px;
    padding-bottom: 30px;

    width:300px;
    height:300px;

    visibility: hidden;
  }

  /* Center the QR image */
  .qr-code-image{
    margin:auto;
    display:block;
  }

  /* Padding for the tableURL that appears above each QR image */
  .tableurl{
    padding:20px;
  }

  /* Make the 6-character code stand out */
  .code{
    font-weight: bold;
  }

  .qr-url{
    overflow-wrap: break-word;
  }
</style>